<!--资源中心菜单-->
<template>
    <div class="menu-container">
<!--        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">一体化教研统计</div>-->
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">个人备课</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">协同备课</div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">已发布备课</div>
        <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">听评课</div>
        <div @click="changeItem('6')" :class="activeItem==='6'?'menu-item menu-active':'menu-item'">作业管理</div>
    </div>
</template>

<script>

export default {
    name:'eduResearchMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"2",
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
    }
}

</script>

<style scoped>
.menu-container{
    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
</style>